import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, ShieldCheck, CalendarCheck } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function CureSection() {
  const phases = [{
    number: '01',
    title: 'ATRACCIÓN DE PACIENTES CALIFICADOS',
    body: 'Segmentamos personas en tu área que buscan activamente tu especialidad y tienen capacidad de pago o seguro médico.',
    icon: Target
  }, {
    number: '02',
    title: 'AUTORIDAD CLÍNICA DIGITAL',
    body: 'Posicionamos tu clínica en el Top 3 de Google para tu especialidad. Construimos reseñas de 5 estrellas. Creamos contenido de autoridad médica que genera confianza antes de la cita.',
    icon: ShieldCheck
  }, {
    number: '03',
    title: 'SISTEMA ANTI NO-SHOW',
    body: 'Automatizamos recordatorios por WhatsApp, SMS y Email. Implementamos sistema de depósito previo. Creamos flujo de reactivación para pacientes inactivos.',
    icon: CalendarCheck
  }];
  return <section className="py-24 px-4 md:px-8" data-id="element-7">
      <div className="max-w-5xl mx-auto" data-id="element-8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-9">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-10">
            La Cura —{' '}
            <span className="text-gold" data-id="element-11">Sistema A.C.E.™ Clínico</span>
          </h2>
          <div className="w-20 h-1 bg-emerald mx-auto rounded-full" data-id="element-12"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-13">
          {phases.map((phase, index) => {
          const Icon = phase.icon;
          return <motion.div key={index} variants={cardVariants} className="bg-[#0a0a0a] border border-white/5 p-8 rounded-xl flex flex-col items-center text-center hover:border-gold/30 transition-colors duration-300" data-id="element-14">
                <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-6" data-id="element-15">
                  <Icon className="w-8 h-8 text-emerald" data-id="element-16" />
                </div>
                <div className="text-gold font-black text-xl mb-2 tracking-widest" data-id="element-17">
                  FASE {phase.number}
                </div>
                <h3 className="text-lg font-bold text-white mb-4 h-14 flex items-center justify-center" data-id="element-18">
                  {phase.title}
                </h3>
                <p className="text-gray-400 text-base leading-relaxed" data-id="element-19">
                  {phase.body}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}